
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","stroke":"currentColor","stroke-width":".3"}},[_c('path',{attrs:{"d":"M12.5 14.437a.473.473 0 01-.163-.029l-.014-.005a.457.457 0 01-.156-.1l-2.812-2.812a.468.468 0 11.663-.662l2.012 2.012V6.472a.469.469 0 11.938 0v6.368l2.012-2.013a.468.468 0 11.662.663l-2.812 2.813a.477.477 0 01-.154.1l-.016.006a.453.453 0 01-.16.028z"}}),_c('path',{attrs:{"d":"M7.344 17.234A2.346 2.346 0 015 14.89v-.313a.469.469 0 01.938 0v.313a1.408 1.408 0 001.406 1.406h10.313a1.408 1.408 0 001.406-1.406v-.313a.469.469 0 01.938 0v.313a2.346 2.346 0 01-2.344 2.344z"}})])])
          )
        }
      }
    